const liveLessonActionTypes = {
	GET_LIVE_LESSON_URLS_START: "GET_LIVE_LESSON_URLS_START",
	GET_LIVE_LESSON_URLS_FAILURE: "GET_LIVE_LESSON_URLS_FAILURE",
	GET_LIVE_LESSON_URLS_SUCCESS: "GET_LIVE_LESSON_URLS_SUCCESS",
};

export default liveLessonActionTypes;
